<template>
  <div>
    <div class="batch-action-container">
      <div class="select-all">
        <label>All/none</label>
        <Checkbox :checked="isAllSelected" @change="onToggleAll" />
      </div>
      <div class="comment">
        <label>Version comment</label>
        <InputField v-model="updateComment" type="text" class="form-input" />
      </div>

      <div>
        <tol-button
          v-if="['Time Sheets', 'Expense Reports'].includes(searchTable)"
          :button-type="'minor'"
          class="batch-action submit"
          icon-name="upload"
          tooltip="SUBMIT"
          @click="emitBatchAction('SUBMIT')"
        >
        </tol-button>
        <tol-button
          v-if="['Time Sheets', 'Expense Reports', 'Assignments'].includes(searchTable)"
          :button-type="'minor'"
          class="batch-action approve"
          icon-name="check"
          tooltip="APPROVE"
          @click="emitBatchAction('APPROVE')"
        >
        </tol-button>

        <tol-button
          v-if="
            ['Time Sheets', 'Expense Reports', 'Assignments', 'Perm Placements'].includes(
              searchTable
            )
          "
          :button-type="'minor'"
          class="batch-action reject"
          icon-name="times"
          tooltip="REJECT"
          @click="emitBatchAction('REJECT')"
        >
        </tol-button>

        <tol-button
          v-if="['Time Sheets', 'Expense Reports', 'Perm Placements'].includes(searchTable)"
          :button-type="'minor'"
          class="batch-action process"
          icon-name="check-double"
          tooltip="PROCESS"
          @click="emitBatchAction('PROCESS')"
        >
        </tol-button>
        <tol-button
          v-if="['Time Sheets', 'Expense Reports', 'Assignments'].includes(searchTable)"
          button-type="minor"
          class="batch-action obsolete"
          icon-name="ban"
          tooltip="OBSOLETE"
          @click="emitBatchAction('OBSOLETE')"
        >
        </tol-button>
        <tol-button
          v-if="['Time Sheets', 'Expense Reports'].includes(searchTable)"
          :button-type="'minor'"
          class="batch-action re-open"
          icon-name="undo"
          tooltip="reopen"
          @click="emitBatchAction('REOPEN')"
        >
        </tol-button>

        <tol-button
          v-if="['Assignments'].includes(searchTable)"
          :button-type="'minor'"
          class="batch-action process"
          icon-name="user-edit"
          tooltip="UPDATE APPROVER"
          @click="emitBatchAction('UPDATE_APPROVER')"
        >
        </tol-button>
      </div>
      <tol-alt-button
        v-if="['Time Sheets', 'Expense Reports'].includes(searchTable)"
        label="Batch PDF"
        icon-name="file-pdf"
        @click="emitPDFBatchAction('PDF')"
      />
    </div>
    <div class="form-wrapper">
      <div v-if="showApproverForm" class="approver-form">
        <div class="action-group">
          <tol-type-ahead
            :search-params="{
              url: '/assignments/user-quick-search',
              searchKeys: ['username', 'first_name', 'last_name', 'users.email'],
              objectType: 'assignmentUser',
              urlParams: {
                ...referenceNumbers
              }
            }"
            :icon-config="{ label: 'search' }"
            :allow-empty-search="true"
            display-property="display_name"
            :no-clear-search="true"
            class="blue"
            @select-item="onSelectApprover($event, 'REMOVE')"
          >
            <template v-slot="{ value }">
              <span>{{ value.last_name }}, {{ value.first_name }} ({{ value.username }})</span
              ><span v-if="value.email">- {{ value.email }}</span>
              <span v-if="value.userType">{{ value.userType }}</span>
            </template>
          </tol-type-ahead>
          <tol-alt-button
            label="remove"
            icon-name="user-minus"
            :disabled="true"
            @click="onClickUserRemove()"
          />
        </div>

        <div class="action-group">
          <tol-type-ahead
            :search-params="{
              url: '/assignments/user-quick-search',
              searchKeys: ['username', 'first_name', 'last_name', 'users.email'],
              objectType: 'assignmentUser',
              urlParams: {
                ...client
              }
            }"
            :icon-config="{ label: 'search' }"
            :allow-empty-search="true"
            display-property="display_name"
            :no-clear-search="true"
            class="blue"
            @select-item="onSelectApprover($event, 'ADD')"
          >
            <template v-slot="{ value }">
              <span>{{ value.last_name }}, {{ value.first_name }} ({{ value.username }})</span
              ><span v-if="value.email">- {{ value.email }}</span>
              <span v-if="value.userType">{{ value.userType }}</span>
            </template>
          </tol-type-ahead>
          <tol-alt-button label="add approver" icon-name="user-plus" @click="onClickUserAdd()" />
        </div>
        <div class="action-group">
          <div
            v-if="selectedUserToAdd && selectedUserToRemove"
            class="replace-user"
            @click="onClickReplaceUser()"
          >
            <span><font-awesome-icon icon="people-arrows"/></span>
            {{ replaceUserLabel }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TolButton from '@/app/components/TolButton';
import InputField from '@/app/components/InputField';
import TolAltButton from '@/app/components/TolAltButton';
import TolTypeAhead from '@/app/components/TolTypeAhead';
import Checkbox from '@/app/components/Checkbox';
import {
  AdvancedSearchGetters,
  AdvancedSearchActions
} from '@/app/features/advanced-search/advanced-search.keys';

export default {
  components: {
    TolButton,
    InputField,
    TolAltButton,
    Checkbox,
    TolTypeAhead
  },
  props: {
    searchTable: {
      type: String,
      required: true
    },
    showApproverForm: {
      type: Boolean,
      default: false
    },
    selectedRefs: {
      type: Array,
      required: true
    },
    selectedClients: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedUserToAdd: null,
      selectedUserToRemove: null,
      updateComment: ''
    };
  },
  computed: {
    isAllSelected() {
      return this.$store.getters[AdvancedSearchGetters.IsAllSelected];
    },
    selectedSearchResults() {
      return this.$store.getters[AdvancedSearchGetters.SelectedSearchResults];
    },
    replaceUserLabel() {
      return this.selectedUserToRemove && this.selectedUserToAdd
        ? `Replace ${this.selectedUserToRemove.display_name} with ${
            this.selectedUserToAdd.display_name
          }`
        : '';
    },
    referenceNumbers() {
      let refs = this.selectedRefs.length > 0 ? this.selectedRefs.join(',') : '';
      return {
        refs
      };
    },
    client() {
      let client_id = this.selectedClients.length > 0 ? this.selectedClients.join(',') : '';
      return {
        client_id
      };
    }
  },
  methods: {
    emitBatchAction(action) {
      this.$emit('batch-action', {
        action,
        comment: this.updateComment
      });
    },
    emitPDFBatchAction(action) {
      this.$emit('PDF', {
        action,
        comment: this.updateComment
      });
    },
    onToggleAll(evt) {
      this.$store.dispatch(AdvancedSearchActions.SelectDeselectAllResults, evt.checked);
    },
    onSelectApprover(evt, action) {
      if (action === 'REMOVE') {
        this.selectedUserToRemove = evt;
      } else if (action === 'ADD') {
        this.selectedUserToAdd = evt;
      }
    },
    onClickUserRemove() {
      let user = {
        add: null,
        remove: this.selectedUserToRemove
      };
      if (this.selectedUserToRemove) {
        this.$emit('remove-user', {
          user,
          comment: this.updateComment
        });
      }
    },
    onClickUserAdd() {
      let user = {
        add: this.selectedUserToAdd,
        remove: null
      };

      if (this.selectedUserToAdd) {
        this.$emit('add-user', {
          user,
          comment: this.updateComment
        });
      }
    },
    onClickReplaceUser() {
      let user = {
        add: this.selectedUserToAdd,
        remove: this.selectedUserToRemove
      };
      if (this.selectedUserToAdd && this.selectedUserToRemove) {
        this.$emit('replace-user', {
          user,
          comment: this.updateComment
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors';
@import '@/app/styles/variables';

.batch-action-container {
  display: flex;
  position: relative;
  justify-content: space-between;
  background-color: $background-level-3;
  padding: 60px;
  width: 100%;
  margin-top: 30px;

  .select-all {
    display: flex;
    flex-direction: column;
    text-transform: uppercase;
    font-size: 0.8em;
    align-items: center;
  }

  .batch-action {
    width: 50px;
    height: 50px;
    font-size: 1.5em;
    margin-right: 20px;
    color: $white;
    border-radius: 100%;
    background-color: $secondary-green;
    &.submit {
      background-color: $orange;
    }
    &.submit:hover {
      background-color: $secondary-orange;
    }
    &.approve {
      background-color: $blue;
    }
    &.approve:hover {
      background-color: $dark-blue;
    }
    &.reject {
      background-color: $red;
    }
    &.obsolete {
      background-color: $red;
    }
    &.reject:hover {
      background-color: $secondary-red;
    }
    &.re-open {
      background-color: $black;
    }
    &.disabled {
      background-color: $light-grey-2;
      color: $light-grey-1;
      &:hover {
        background-color: $light-grey-2;
        color: $light-grey-1;
        cursor: not-allowed;
      }
    }
  }
  .comment {
    border: 1px solid $row-border;
    display: flex;
    align-items: center;
    label {
      padding: 0 8px;
      background-color: $row-border;
      display: flex;
      align-items: center;
      height: 100%;
    }
    .input-container {
      width: 400px;
    }
    input {
      width: 100%;
    }
  }
}
.form-wrapper {
  background-color: $background-level-3;
  display: flex;
  padding: 0 60px;
  .approver-form {
    display: flex;
    flex-direction: column;
    width: 640px;

    .action-group {
      display: flex;
      margin-bottom: 12px;
      div.search-container {
        flex-basis: 70%;
      }
      div.wrapper {
        margin-left: 10px;
      }

      .replace-user {
        border: 1px solid $blue;
        padding: 12px 8px;
        &:hover {
          cursor: pointer;
          color: $white;
          background-color: $blue;
        }
      }
    }
  }
}
</style>
